import Markdown from "markdown-to-jsx";
import React from "react";

type Props = {
  content: string;
  className?: string | undefined;
  as?: keyof JSX.IntrinsicElements | undefined;
};
export const MarkdownRenderer: React.FC<Props> = ({
  content,
  className,
  as
}) => (
  <Markdown
    className={className}
    options={{
      wrapper: as,
      overrides: {
        a: {
          props: {
            as: "a",
            target: "_blank",
            rel: "noopener noreferrer",
            underline: true
          }
        },
        b: {
          props: {
            as: "strong"
          }
        },
        h2: {
          props: {
            as: "h4"
          }
        },
        li: {
          props: {
            as: "li"
          }
        },
        p: {
          props: {
            as: "p"
          }
        },
        span: {
          props: {
            as: "span"
          }
        }
      }
    }}
  >
    {content}
  </Markdown>
);
